import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';


import ReactTable from "react-table";
import "react-table/react-table.css";

import Spinner from 'react-spinkit';

import moment from 'moment';

import * as actions from '../../actions/eventos';

import IconSave from 'react-icons/lib/md/save';


import {api, request, API_URL} from '../../actions/_request';



const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

class ModalEventos extends React.Component{
	constructor(props) {

        super(props);

        this.state = {
           	evento : {
              id : '',
              titulo : '',
              lugar : '',
              horario : '',
              expositor : '',
              fecha_evento : moment().format('Y-MM-DD'),
              fecha_inicio : moment().format('Y-MM-DD'),
              fecha_fin : moment().add(1, 'days').format('Y-MM-DD'),

            },

            action : 'save',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this); 
    }

    componentDidMount()
    {    
        let prospectoid = this.props.prospectoid;
        let self = this;

        let {evento} = this.state;
              
        if(prospectoid > 0 && prospectoid != self.state.evento.id)
        {
          api().get(`/evento/edit/${prospectoid}`)
            .then(function(response)
            {          
                if(response.status === 200)
                {                
                    self.setState({
                        evento: response.data,
                        action: 'update',
                    });
                }
            });
        }
        else if(prospectoid == null && self.state.evento.id)
        {            
            self.resetModal();
        }
    }

    handleInputChange(event) {

        let {evento} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        evento[name] = value;
        this.setState({
            evento : evento
        });
    }

    handleSubmit(evt){
      let {evento, action} = this.state;
      evt.preventDefault();
      let _self = this;
      console.log(evento)

      this.props[action](evento, (data)=>{
          _self.props.toggle();
      });

    }


    render(){
    	let { evento } = this.state;
    	return(
    		<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal_cliente">
                <form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                	<div className="row">
                		<div className="col-12 col-sm-4">
                			<div className="form-group">
                   				<label>Titulo:</label>
                   				<Input
                            required
                   					placeholder=""
                   					type="text"
                   					name="titulo"
                   					value={evento.titulo}
                   					onChange={this.handleInputChange}
                   				/>
                   			</div>
                		</div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group">
                          <label>Lugar:</label>
                          <Input
                            required
                            placeholder=""
                            type="text"
                            name="lugar"
                            value={evento.lugar}
                            onChange={this.handleInputChange}
                          />
                        </div>
                    </div>
                     <div className="col-12 col-sm-4">
                      <div className="form-group">
                          <label>Expositor:</label>
                          <Input
                            required
                            placeholder=""
                            type="text"
                            name="expositor"
                            value={evento.expositor}
                            onChange={this.handleInputChange}
                          />
                        </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group">
                          <label>Fecha Evento:</label>
                          <Input
                            required
                            placeholder=""
                            type="date"
                            name="fecha_evento"
                            value={evento.fecha_evento}
                            onChange={this.handleInputChange}
                          />
                        </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group">
                          <label>Horario:</label>
                          <Input
                            required
                            placeholder=""
                            type="text"
                            name="horario"
                            value={evento.horario}
                            onChange={this.handleInputChange}
                          />
                        </div>
                    </div>
                	</div>
                  <div className='row'>
                    <div className="col-12 col-sm-4">
                      <div className="form-group">
                          <label>Fecha Inicio Registro:</label>
                          <Input
                            placeholder=""
                            type="date"
                            name="fecha_inicio"
                            value={evento.fecha_inicio}
                            onChange={this.handleInputChange}
                          />
                        </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group">
                          <label>Fecha Fin Registro:</label>
                          <Input
                            placeholder=""
                            type="date"
                            name="fecha_fin"
                            value={evento.fecha_fin}
                            onChange={this.handleInputChange}
                          />
                        </div>
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.eventos.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit">
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
    	);
    }
}

function mapStateToProps(state, ownProps) {
    return {
        eventos : state.eventos,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(ModalEventos)


// WEBPACK FOOTER //
// ./src/views/eventos/formEvento.js